import React from 'react'
import useStyles from '../../hooks/useStyles'
import styles from './Comment.module.scss'

function Comment() {
    const cs = useStyles(styles)
    
  return (
    <div className={cs('comment')}>
        <h2></h2>
    </div>
  )
}

export default Comment